import { render, staticRenderFns } from "./SpecTabPane.vue?vue&type=template&id=c0cf6aea&"
import script from "./SpecTabPane.vue?vue&type=script&lang=js&"
export * from "./SpecTabPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports